// extracted by mini-css-extract-plugin
export var background = "_78-0";
export var container = "_78-1";
export var contentItem = "_78-7";
export var extendedWarranty = "_78-5";
export var link = "_78-d";
export var modal = "_78-b";
export var modalCloseButton = "_78-9";
export var modalContent = "_78-3";
export var modalContentMain = "_78-6";
export var modalImageLogo = "_78-8";
export var modalLogo = "_78-a";
export var modalSideImage = "_78-4";
export var preview = "_78-c";
export var redoModal = "_78-2";